<div class="container-fluid">
    <dx-load-panel
        [hideOnOutsideClick]="false"
        shadingColor="rgba(0,0,0,0.4)"
        [(visible)]="loadingIndicator">
    </dx-load-panel>
    <div class="col-sm-10 offset-1">
        <form class="example-form" [formGroup]="addPurchaseOrderForm">
            <br>
            <app-panel [footer]="true">
                <div class="heading">{{customerId ? 'Edit' : 'Add'}} Customers</div>
                <div class="body">
                    <div class="form-group row d-flex align-items-center">
                        <div class="col-sm-2">
                            <div class="dx-field">
                                <div>Customer Type <span>*</span> : </div>
                                <dx-select-box [inputAttr]="{ autocomplete: 'off' }"  [items]="customerType" placeholder="Choose Customer Type" [showClearButton]="true" displayExpr="customerTypeName" valueExpr="customerTypeId" [searchEnabled]="true" formControlName="customerTypeId">
                                    <dx-validator>
                                        <dxi-validation-rule type="required" message="Customer type is required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-select-box>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="dx-field">
                                <div>Name <span>*</span> :</div>
                                <dx-text-box [required]="true" [inputAttr]="{ autocomplete: 'off' }" [maxLength]="70" placeholder="Customer Name" formControlName="customerName">
                                    <dx-validator>
                                        <dxi-validation-rule type="required" message="Customer name is required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-text-box>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="dx-field">
                                <div>Arabic Name:</div>
                                <dx-text-box [inputAttr]="{ autocomplete: 'off' }" [maxLength]="70" placeholder="Customer Arabic Name" formControlName="arabicCustomerName"></dx-text-box>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="dx-field">
                                <div>Trade Name:</div>
                                <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Trade Name" formControlName="abb"></dx-text-box>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="dx-field">
                                <div>Country <span>*</span> :</div>
                                <dx-select-box [inputAttr]="{ autocomplete: 'off' }"  
                                [items]="countries" placeholder="Choose Country"
                                 [showClearButton]="false" displayExpr="countryName" valueExpr="countryId"
                                  (onValueChanged)="filterProvinces(countryId.value)" [searchEnabled]="true" formControlName="countryId">
                                    <dx-validator>
                                        <dxi-validation-rule type="required" message="Country is required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-select-box>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="dx-field">
                                <div>Province <span>*</span> :</div>
                                <dx-select-box [inputAttr]="{ autocomplete: 'off' }"  [items]="provinceList"  placeholder="Choose Province"
                                    [showClearButton]="false" displayExpr="provenceName" valueExpr="provenceId"
                                    [searchEnabled]="true"
                                    formControlName="provinceId"
                                    [disabled]="!addPurchaseOrderForm.get('countryId').value"
                                    (onValueChanged)="filterCity(addPurchaseOrderForm.get('provinceId').value)">
                                    <dx-validator>
                                        <dxi-validation-rule type="required" message="Province is required">
                                        </dxi-validation-rule>
                                    </dx-validator>
                                </dx-select-box>
                                <!-- <dx-select-box [inputAttr]="{ autocomplete: 'off' }"  [items]="Province" 
                                    placeholder="Choose Province" [showClearButton]="true" 
                                    displayExpr="provenceName" valueExpr="provenceId" [searchEnabled]="true" formControlName="provinceId">
                                    <dx-validator>
                                        <dxi-validation-rule type="required" message="Province is required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-select-box> -->
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="dx-field">
                                <div>City <span>*</span> :</div>
                                <dx-select-box [inputAttr]="{ autocomplete: 'off' }"  [items]="cityList"  placeholder="Choose City" [showClearButton]="false"
                                displayExpr="cityName" valueExpr="cityId" [searchEnabled]="true"
                                [disabled]="!addPurchaseOrderForm.get('provinceId').value"
                                formControlName="cityId">
                                <dx-validator>
                                    <dxi-validation-rule type="required" message="City is required">
                                    </dxi-validation-rule>
                                </dx-validator>
                            </dx-select-box>
                                <!-- <dx-select-box [inputAttr]="{ autocomplete: 'off' }" 
                                     [items]="cities" placeholder="Choose City" 
                                     [showClearButton]="true" displayExpr="cityName"
                                      valueExpr="cityId" [searchEnabled]="true" formControlName="cityId">
                                    <dx-validator>
                                        <dxi-validation-rule type="required" message="City is required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-select-box> -->
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="dx-field">
                                <div>Postal Code: </div>
                                <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Postal Code" formControlName="postalCode"></dx-text-box>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="dx-field">
                                <div>PO Box:</div>
                                <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="PO BOX" formControlName="poBox"></dx-text-box>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="dx-field">
                                <div>Currency <span>*</span> :</div>
                                <dx-select-box [inputAttr]="{ autocomplete: 'off' }"
                                  [items]="currency" placeholder="Choose Currency" [disabled]="currency?.length == 0"
                                  [showClearButton]="true" [value]="defaultSelectedItem" displayExpr="currencySymbol"
                                   valueExpr="currencyId" [searchEnabled]="true" formControlName="defaultCurrencyId">
                                    <dx-validator>
                                        <dxi-validation-rule type="required" message="Default currency is required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-select-box>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="dx-field">
                                <div>Postal Address <span>*</span> :</div>
                                <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Postal Address" formControlName="postalAddress">
                                    <dx-validator>
                                        <dxi-validation-rule type="required" message="Postal address is required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-text-box>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="dx-field">
                                <div>Postal Arabic Address:</div>
                                <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Postal Arabic Address" formControlName="postalAddressArabic"></dx-text-box>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="dx-field">
                                <div>CRNO:</div>
                                <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="CRNO" formControlName="customerCRNO"></dx-text-box>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="dx-field">
                                <div>Website:</div>
                                <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Website" formControlName="website"></dx-text-box>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="dx-field">
                                <div>Vat Tax Group:</div>
                                <dx-select-box [inputAttr]="{ autocomplete: 'off' }"  [items]="vattaxGroup" placeholder="Choose Vat Tax Group" [showClearButton]="true" displayExpr="tagGroupName" valueExpr="vattaxGroupId" [searchEnabled]="true" formControlName="vattaxGroupId">
                                </dx-select-box>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="dx-field">
                                <div>Vat Number:</div>
                                <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Vat Number" formControlName="vatnumber"></dx-text-box>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="dx-field">
                                <div>NTN:</div>
                                <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="NTN" formControlName="ntn"></dx-text-box>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="dx-field">
                                <div>Branch:</div>
                                <dx-select-box [inputAttr]="{ autocomplete: 'off' }"  [items]="branches" placeholder="Choose Company Branch" [showClearButton]="true" displayExpr="companyBranchName" valueExpr="companyBranchId" [searchEnabled]="true" formControlName="companyBranchId">
                                </dx-select-box>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <mat-checkbox formControlName="isRegisteredWithSalesTax" color="primary" matTooltipPosition="above">Registered WIth Sales Tax</mat-checkbox>
                        </div>
                        <div class="col-sm-3">
                            <mat-checkbox formControlName="isBt" color="primary" matTooltipPosition="above">BT</mat-checkbox>
                        </div>
                        <div class="col-sm-3">
                            <mat-checkbox formControlName="hobusiness" color="primary" matTooltipPosition="above">HO Business</mat-checkbox>
                        </div>
                        <div class="col-sm-3">
                            <div class="dx-field">
                                <div>Payment Type <span>*</span> :</div>
                                <dx-select-box [inputAttr]="{ autocomplete: 'off' }"  [items]="paymentType" 
                                    placeholder="Choose Payment Type" 
                                    [showClearButton]="true" 
                                    displayExpr="paymentTypeName" 
                                    valueExpr="paymentTypeId" 
                                    [searchEnabled]="true"  
                                    formControlName="paymentTypeId"
                                    (onValueChanged)="showPaymentType($event.value)">
                                    <dx-validator>
                                        <dxi-validation-rule type="required" message="Payment type is required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-select-box>
                            </div>
                        </div>
                    </div>

                    <div class="mt-2">
                        <app-panel [footer]="false" [backArrow]="false">
                            <div class="heading">
                                Credit Payment
                            </div>
                            <div class="body" [hidden]="!showCash">
                                <div class="form-group row">
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>1st Reminder (Amt)</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="Amount Reminder 1" formControlName="amountReminder1"></dx-text-box>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>2nd Reminder (Amt)</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="Amount Reminder 2" formControlName="amountReminder2"></dx-text-box>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>1st Reminder (D)</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="Days Reminder 1" formControlName="daysReminder1"></dx-text-box>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>2nd Reminder (D)</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="Days Reminder 2" formControlName="daysReminder2"></dx-text-box>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>Block Days</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="Block Days" formControlName="blockDays"></dx-text-box>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>Unblock Amount</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="Unblock Amount" formControlName="unBlockAmount"></dx-text-box>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>Unblock Days</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="Unblock Days" formControlName="unBlockDays"></dx-text-box>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>Grace Amount</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="Grace Amount" formControlName="graceAmount"></dx-text-box>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </app-panel>
                    </div>
                    <div class="mt-2">
                        <app-panel [footer]="false" [backArrow]="false">
                            <div class="heading">
                                Invoice Payment
                            </div>
                            <div class="body" [hidden]="!showCheck">
                                <div class="form-group row">
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>Aging Days</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="MLR Aging Days" formControlName="mlragingDays"></dx-text-box>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>Invoice Count</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="MLR Invoice Count" formControlName="mlrinvCount"></dx-text-box>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>Amount</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="MLR Amount" formControlName="mlramount"></dx-text-box>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>Block Amount</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="MLR Block Amount" formControlName="mlrblockAmount"></dx-text-box>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>Auto Unblock In</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="MLR Auto Unblock In" formControlName="mlrautoUnBlockin"></dx-text-box>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>Days</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="MLAR Days" formControlName="mlardays"></dx-text-box>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>Invoice Count</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="MLAR Invoice Count" formControlName="mlarinvCount"></dx-text-box>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>Amount</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="MLAR Amount" formControlName="mlaramount"></dx-text-box>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="dx-field">
                                            <div>Cash Aging Days</div>
                                            <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="Cash Aging Days" formControlName="cashAgingDays"></dx-text-box>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </app-panel>
                    </div>
                </div>
                <div class="footer">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="text-right">
                                <dx-button class="mr-2" icon="add" type="default" text= "Customer Branch" (click)="adddCustomerBranch ()" *ngIf="customerId">
                                </dx-button>
                                <dx-button [text]="customerId ? 'Update' : 'Add'" type="default"
                                            class="float-right ml-3"
                                            (click)="!addPurchaseOrderForm.valid || addCustomerInfo(addPurchaseOrderForm)"
                                            [useSubmitBehavior]="true"
                                            >
                                </dx-button>
                            </div>
                        </div>
                    </div>
                </div>
            </app-panel>
        </form>
    </div>
</div>

<dx-popup class="popup" [width]="1000" [height]="550" [showTitle]="true" title="Customer Branch" [dragEnabled]="false" [hideOnOutsideClick]="true" [(visible)]="branchPopUp">
    <div *dxTemplate="let data of 'content'">
        <form [formGroup]="addCustomerBranchContent" >
            <div class="form-group row">
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">Branch Name <span>*</span>:</div>
                        <dx-text-box [inputAttr]="{ autocomplete: 'off' }" [maxLength]="70" placeholder="Branch Name" formControlName="branchName">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Branch Name is required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">Arabic Branch Name</div>
                        <dx-text-box [inputAttr]="{ autocomplete: 'off' }" [maxLength]="70" placeholder="Arabic Branch Name" formControlName="arabicBranchName">
                        </dx-text-box>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">Postal Address <span>*</span>:</div>
                        <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Postal Address" formControlName="postalAddress">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Postal Address is required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">Postal Code</div>
                        <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Postal Code" formControlName="postalCode">
                        </dx-text-box>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">PO BOX Number</div>
                        <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="PO BOX Number" formControlName="poBox">
                        </dx-text-box>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">City <span>*</span>:</div>
                        <dx-select-box [inputAttr]="{ autocomplete: 'off' }"  [items]="cities" placeholder="Choose City" [showClearButton]="true" displayExpr="cityName" valueExpr="cityId" [searchEnabled]="true" formControlName="cityId">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="City is required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">Contact Number</div>
                        <dx-number-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Contact Number" formControlName="contactNo">
                        </dx-number-box>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">Fax Number</div>
                        <dx-number-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Fax Number" formControlName="faxNo">
                        </dx-number-box>
                    </div>
                </div>                
            </div>
            <div class="form-group row">
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">Email Address</div>
                        <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Email Address" formControlName="emailAddress">
                            <dx-validator>
                                <!-- <dxi-validation-rule type="required" message="Email Address is required"></dxi-validation-rule> -->
                                <dxi-validation-rule type="email" message="Invalid email"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">Number of Invoice</div>
                        <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="Number of Invoice" formControlName="noOfInvoice">
                        </dx-text-box>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">Opening Balance Date <span>*</span>:</div>
                        <dx-date-box type="date"  formControlName="openingBalanceDate" style="width: 100%">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Opening balance date is required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-date-box>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">Opening Balance <span>*</span>:</div>
                        <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="number" placeholder="Opening Balance" formControlName="openingBalance">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Opening balance is required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <!-- <div class="col-sm-4">
                    <div class="dx-field">
                        <div class="text-left">Customer Email</div>
                        <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Customer Address" formControlName="customerEmail">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Customer Email is required"></dxi-validation-rule>
                                <dxi-validation-rule type="email" message="Invalid email"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div> -->
                
            </div>
            <div class="form-group row">
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">Branch</div>
                        <dx-select-box [inputAttr]="{ autocomplete: 'off' }"  [items]="branches" placeholder="Choose Company Branch" [showClearButton]="true" displayExpr="companyBranchName" valueExpr="companyBranchId" [searchEnabled]="true" formControlName="companyBranchId">
                        </dx-select-box>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">Sales Man <span>*</span>:</div>
                        <dx-select-box [inputAttr]="{ autocomplete: 'off' }"  [items]="salesMan" placeholder="Choose Sales Man" [showClearButton]="true" displayExpr="employeeName" valueExpr="userId" [searchEnabled]="true" formControlName="salesmanId">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Sales man is required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">Sales Driver</div>
                        <dx-select-box [inputAttr]="{ autocomplete: 'off' }"  [items]="salesDriver" placeholder="Choose Sales Man" [showClearButton]="true" displayExpr="employeeName" valueExpr="userId" [searchEnabled]="true" formControlName="salesDriverId">
                        </dx-select-box>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">Special Instructions</div>
                        <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Special Instructions" formControlName="specialInstruction">
                        </dx-text-box>
                    </div>
                </div>
                <!-- <div class="col-sm-3">
                    <div class="dx-field">
                        <div class="text-left">Account Code</div>
                        <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Account Code" formControlName="accountCode">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Account code is required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div> -->
            </div>
            <div class="form-group row d-flex align-items-center">
                <div class="col-sm-3">
                    <mat-checkbox formControlName="isCustomerLocked" color="primary" matTooltipPosition="above">Lock Customer?</mat-checkbox>
                </div>
                <div class="col-sm-3">
                    <mat-checkbox formControlName="isHeadOffice" color="primary" matTooltipPosition="above">Is Head Office?</mat-checkbox>
                    <!-- <mat-error *ngIf="!addCustomerBranchContent.get('isHeadOffice').value && addCustomerBranchContent.get('isHeadOffice').touched" class="d-block">
                        Head Office is required
                    </mat-error> -->
                </div>
            </div>
            <div text="text-right">
                <div class="float-left mt-2" *ngIf="customerId">
                    Active <dx-check-box formControlName="active"></dx-check-box>
                  </div>
                <dx-button [text]="editCustomerBranch ? 'Update' : 'Add'" type="default"
                    (click)="!addCustomerBranchContent.valid || saveCustomerBranchForm(addCustomerBranchContent)"
                    class="float-right ml-3"
                    [useSubmitBehavior]="true">
                </dx-button>
            </div>
        </form>
    </div>
</dx-popup>

<dx-popup class="popup" [width]="1000" [height]="400" [showTitle]="true"
 title="Customer Contacts" [dragEnabled]="false" [hideOnOutsideClick]="false" [(visible)]="popupVisible">
    <div *dxTemplate="let data of 'content'">
        <form [formGroup]="addCustomerContent" >
            <div class="form-group row">
                <div class="col-sm-4">
                    <div class="dx-field">
                        <div class="text-left">Contact Name <span>*</span>:</div>
                        <dx-text-box [inputAttr]="{ autocomplete: 'off' }" [maxLength]="70"  placeholder="Contact Name" formControlName="contactName">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Customer Name is required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="dx-field">
                        <div class="text-left">Department <span>*</span>:</div>
                        <dx-select-box [inputAttr]="{ autocomplete: 'off' }"  [items]="departments" placeholder="choose Department" [showClearButton]="true" displayExpr="departmentName" valueExpr="departmentId" [searchEnabled]="true" formControlName="departmentId">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Department is required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="dx-field">
                        <div class="text-left">Designation</div>
                        <dx-select-box [inputAttr]="{ autocomplete: 'off' }"  [items]="designation" placeholder="Choose Designation" [showClearButton]="true" displayExpr="designationName" valueExpr="designationId" [searchEnabled]="true" formControlName="designationId">
                            <!-- <dx-validator>
                                <dxi-validation-rule type="required" message="designation is required"></dxi-validation-rule>
                            </dx-validator> -->
                        </dx-select-box>
                    </div>
                </div>
            </div>
            <!--</div>-->
            <div class="form-group row">
                <div class="col-sm-4">
                    <div class="dx-field">
                        <div class="text-left">Phone Number</div>
                        <dx-number-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Land Line" formControlName="phoneNumber"></dx-number-box>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="dx-field">
                        <div class="text-left">Mobile Number</div>
                        <dx-number-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Mobile Number" formControlName="mobileNumber"></dx-number-box>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="dx-field">
                        <div class="text-left">Fax Number</div>
                        <dx-number-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Fax Number" formControlName="faxNumber"></dx-number-box>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-sm-6">
                    <div class="dx-field">
                        <div class="text-left">Email Address</div>
                        <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Email Address" formControlName="emailAddress">
                            <dx-validator>
                                <!-- <dxi-validation-rule type="required" message="Email Address is required"></dxi-validation-rule> -->
                                <dxi-validation-rule type="email" message="Invalid email"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="dx-field">
                        <div class="text-left">Extention</div>
                        <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Extention" formControlName="ext"></dx-text-box>
                    </div>
                </div>
            </div>
            <div text="text-right">
                <dx-button [text]="editContact ? 'Update' : 'Add'" type="default"
                           (click)="!addCustomerContent.valid || (editContact ? updateCustomerContactForm(addCustomerContent) : saveCustomerContactForm(addCustomerContent))"
                           class="float-right ml-3"
                           [useSubmitBehavior]="true">
                </dx-button>
            </div>
        </form>
    </div>
</dx-popup>

<div class="container-fluid" *ngIf="customerId">
    <div class="col-sm-10 offset-1">
        <div fxLayout="column">
            <div class="flex-p">
              <mat-card class="custom-card">
                <mat-card-content>
                  <div class="remove-side-spacing">
                    <dx-data-grid 
                      id="gridContainer10" 
                      [dataSource]="customerBranches"  
                      keyExpr="customerBranchId"
                      [masterDetail]="{ enabled: true, template: 'detail' }"           
                      [columnAutoWidth]="true" 
                      [showBorders]="true">
                      <dxo-paging [pageSize]="10"></dxo-paging>
                      <dxo-filter-row [visible]="true" ></dxo-filter-row>
                      <dxi-column dataField="branchName"  caption="Branch Name" cssClass="text-left"></dxi-column>
                      <dxi-column dataField="companyBranchName"  caption="Company Branch Name" cssClass="text-left"></dxi-column>
                      <dxi-column dataField="salesmanName" caption="Salesman"  cssClass="text-left"></dxi-column>
                      <dxi-column dataField="specialInstruction" caption="Special Instructions" cssClass="text-left"></dxi-column>
                      <dxi-column dataField="cityName" caption="City" cssClass="text-left"></dxi-column>
                      <dxi-column dataField="emailAddress" caption="Email" cssClass="text-left"></dxi-column>
                      <dxi-column caption="Add Customer Contacts" cssClass="text-center" cellTemplate="contactTemplate"></dxi-column>
                      <dxi-column dataField="isHeadoffice" caption="H.Office" [width]="80" 
                      cssClass="text-center" cellTemplate="headOffTemplate" [allowFiltering]="false"></dxi-column>
                      <dxi-column dataField="active" caption="Status" [width]="80" cssClass="text-center" cellTemplate="statusTemplate" [allowFiltering]="false"></dxi-column>
                      <dxi-column caption="Actions" [width]="100"  cssClass="text-center" cellTemplate="cellTemplate" [allowFiltering]="false"></dxi-column>
                      <div class="employee dx-row" *dxTemplate="let d of 'contactTemplate'" >
                        <div class="main-row">
                            <button  mat-icon-button matTooltip="Add Item" (click)="adddCustomerContent(d.data)">
                                <mat-icon color="primary">add_box</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div class="employee dx-row" *dxTemplate="let d of 'headOffTemplate'" >
                        <div class="main-row">
                          <span class="text-green">{{d.data.isHeadoffice ? 'Yes'  : 'No'}}</span>
                        </div>
                      </div>
                      <div class="employee dx-row" *dxTemplate="let d of 'statusTemplate'" >
                        <div class="main-row">
                          <span [ngClass]="d.data.active ? 'text-green' : 'text-red'">{{d.data.active ? 'Active'  : 'Inactive'}}</span>
                        </div>
                      </div>
                      headOffTemplate
                      <div *dxTemplate="let data of 'cellTemplate'">
                        <button  mat-icon-button
                                 matTooltip="Edit Item" (click)="editBranch(data.data.customerBranchId)" UserAccessibility="canModify">
                          <mat-icon color="primary">edit</mat-icon>
                        </button>
                        <button type="button" mat-icon-button matTooltip="Delete Item" [swal]="deleteSwal" UserAccessibility="canDelete" *ngIf="data.data.active">
                          <mat-icon color="warn">delete</mat-icon>
                        </button>
                        <swal #deleteSwal title="Are you sure want to delete ?" text="This cannot be undone" type="question"
                              [showCancelButton]="true" [focusCancel]="true"
                              (confirm)="deleteCustomerBranch(data.data.customerBranchId)">
                        </swal>
                      </div>
                      <div *dxTemplate="let rows of 'detail'">
                        <dx-data-grid 
                            [dataSource]="rows.data.customerContactList"
                            [showBorders]="true"
                            [columnAutoWidth]="true">
                                <dxi-column dataField="contactName"></dxi-column>
                                <dxi-column dataField="departmentName"></dxi-column>
                                <dxi-column dataField="designationName"></dxi-column>
                                <dxi-column dataField="emailAddress"></dxi-column>
                                <dxi-column dataField="mobileNumber"></dxi-column>
                                <dxi-column dataField="phoneNumber"></dxi-column>
                                <dxi-column dataField="emailAddress"></dxi-column>
                                <dxi-column dataField="active" caption="Status" [width]="80" cssClass="text-center" cellTemplate="statusTemplate" [allowFiltering]="false"></dxi-column>
                                <dxi-column caption="Actions" [width]="100"  cssClass="text-center" cellTemplate="cellTemplate" [allowFiltering]="false"></dxi-column>
                                <div class="employee dx-row" *dxTemplate="let d of 'statusTemplate'" >
                                    <div class="main-row">
                                      <span [ngClass]="d.data.active ? 'text-green' : 'text-red'">{{d.data.active ? 'Active'  : 'Inactive'}}</span>
                                    </div>
                                </div>
                                <div *dxTemplate="let data of 'cellTemplate'">
                                    <button  mat-icon-button
                                             matTooltip="Edit Item" (click)="editCustomerContact(data.data)" UserAccessibility="canModify">
                                      <mat-icon color="primary">edit</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button matTooltip="Delete Item" [swal]="deleteSwal" UserAccessibility="canDelete" *ngIf="data.data.active">
                                      <mat-icon color="warn">delete</mat-icon>
                                    </button>
                                    <swal #deleteSwal title="Are you sure want to delete ?" text="This cannot be undone" type="question"
                                          [showCancelButton]="true" [focusCancel]="true"
                                          (confirm)="deleteCustomerBranchContact(data.data.customerContactId)">
                                    </swal>
                                </div>
                        </dx-data-grid>       
                      </div>
                    </dx-data-grid>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
    </div>
</div>
<swal #saveSwal></swal>
